export const SearchTestIdFactory = {
    getSearchBase: () => 'search',
    getSearchInputBase: () => [SearchTestIdFactory.getSearchBase(), 'input'].join('-'),
    getSearchMagnifierButtonBase: () => [SearchTestIdFactory.getSearchBase(), 'magnifier'].join('-'),
    getSearchCloseButtonBase: () => [SearchTestIdFactory.getSearchBase(), 'close'].join('-'),
    getSearchTestId: (testId) => [SearchTestIdFactory.getSearchBase(), testId].join('-'),
    getSearchInputTestId: (testId) => [SearchTestIdFactory.getSearchInputBase(), testId].join('-'),
    getSearchMagnifierButtonTestId: (testId) => [SearchTestIdFactory.getSearchMagnifierButtonBase(), testId].join('-'),
    getSearchCloseButtonTestId: (testId) => [SearchTestIdFactory.getSearchCloseButtonBase(), testId].join('-'),
};
